import React from "react";
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
const AuthNavbar = () => {
    const logistikLogo = ''
    return (
        <React.Fragment>
            <Navbar bg="light" expand="lg" className="navbar-light">
                <Container fluid>
                    <Navbar.Brand><img src={`https://assets.rsabhk.co.id/logo/rsabhk-logo-vedika.png`} alt="Vedika- RSABHK" width="100%" height="auto"/></Navbar.Brand>
                </Container>
            </Navbar>
        </React.Fragment>
    );
}
export default AuthNavbar;